<template>
    <v-card class="pa-3">
        <v-row>
            <v-col>
                <h4 class="bold">Comentarios do Título</h4>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <span v-if="!comentarios.length"
                    >Não há comentarios neste título</span
                >
                <v-list v-else>
                    <v-list-item-group>
                        <v-list-item
                            v-for="(comentario, index) in comentarios"
                            :key="index"
                            class="bg-comentario"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    <strong>
                                        {{ comentario.email_user }}(ID:
                                        {{ comentario.id_user }}/{{
                                            comentario.name_user
                                        }}) - Criado em
                                        {{
                                            FormateData(comentario.dt_criacao)
                                        }}:
                                        <i class="text-gray">{{
                                            comentario.comentario
                                        }}</i>
                                    </strong>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-col>
        </v-row>
        <v-row v-if="addComentario && podeAdicionarComentario">
            <v-col>
                <div class="d-flex align-center mb-1">
                    <span class="mr-1">Novo comentario</span>
                    <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                small
                                color="grey darken-1"
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-information-outline
                            </v-icon>
                        </template>
                        <span>
                            Este comentário é interno e
                            <strong>não é enviado ao cartório</strong>.
                            Se precisar enviar alguma mensagem ao cartório,
                            entre em contato com o contato da Rec.
                        </span>
                    </v-tooltip>
                </div>
                <v-textarea
                    label="Novo comentario"
                    outlined
                    v-model="novoComentario"
                    placeholder="Escreva aqui seu comentario"
                    :maxlength="MAX_COMENTARIO_LENGTH"
                    :counter="MAX_COMENTARIO_LENGTH"
                    :rules="[comentarioRule]"
                    :error-messages="erroComentario"
                    hint="Este comentário é interno e não é enviado ao cartório."
                    persistent-hint
                    rows="4"
                    auto-grow
                    @input="erroComentario = ''"
                >
                </v-textarea>
            </v-col>
        </v-row>
        <v-row v-if="addComentario && podeAdicionarComentario">
            <v-col class="d-flex justify-end">
                <v-btn
                    color="red"
                    dark
                    @click="
                        addComentario = false;
                        erroComentario = '';
                    "
                >
                    <v-icon>mdi-close</v-icon>
                    Cancelar
                </v-btn>
                <v-btn
                    :loading="loadingSave"
                    color="success"
                    class="ml-3"
                    :disabled="!podeSalvar"
                    @click="criarComentario()"
                >
                    <v-icon>mdi-check</v-icon>
                    Salvar
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="!addComentario && podeAdicionarComentario">
            <v-col class="d-flex justify-end">
                <v-btn @click="addComentario = true">
                    <v-icon>mdi-plus</v-icon>
                    Adicionar comentario
                </v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
import moment from 'moment';
import TituloService from '@/services/TituloService';
import Vue from 'vue';

export default {
    name: 'CardComentariosTitulo',
    props: {
        comentarios: {
            type: Array,
            default: () => []
        },
        id_titulo: {
            type: Number,
            default: () => null
        }
    },
    data() {
        return {
            addComentario: false,
            novoComentario: '',
            tituloService: new TituloService(Vue.http, this.$store),
            loadingSave: false,
            erroComentario: '',
            MAX_COMENTARIO_LENGTH: 2000
        };
    },
    computed: {
        podeAdicionarComentario() {
            try {
                if (
                    this.$store &&
                    this.$store.getters &&
                    typeof this.$store.getters.isSuperAdminRecuperi !==
                        'undefined'
                ) {
                    return !!this.$store.getters.isSuperAdminRecuperi;
                }
                const isSuper =
                    this.$store && this.$store.getters
                        ? this.$store.getters.getSuperUser == 1
                        : false;
                const partnerId =
                    this.$store && this.$store.getters
                        ? this.$store.getters.isPartner
                        : null;
                return !!isSuper && !partnerId;
            } catch (e) {
                return false;
            }
        },
        podeSalvar() {
            const texto = (this.novoComentario || '').trim();
            return (
                this.podeAdicionarComentario &&
                !this.loadingSave &&
                texto.length > 0 &&
                texto.length <= this.MAX_COMENTARIO_LENGTH
            );
        }
    },
    methods: {
        comentarioRule(value) {
            const texto = (value || '').trim();
            if (!texto) return 'Informe o comentário.';
            if (texto.length > this.MAX_COMENTARIO_LENGTH)
                return `Limite de ${this.MAX_COMENTARIO_LENGTH} caracteres excedido (${texto.length} enviados).`;
            return true;
        },
        FormateData(data) {
            return moment(data).format('DD/MM/YYYY');
        },
        extrairMensagemErro(error) {
            try {
                const body = error && error.body ? error.body : null;
                if (body) {
                    if (typeof body.msg === 'string') return body.msg;
                    if (typeof body.mensagem === 'string') return body.mensagem;
                    if (typeof body.erro === 'string') return body.erro;
                }
                if (error && error.data) {
                    if (typeof error.data.msg === 'string')
                        return error.data.msg;
                    if (typeof error.data.mensagem === 'string')
                        return error.data.mensagem;
                }
                if (error && typeof error.message === 'string')
                    return error.message;
            } catch (e) {
                console.log(e);
            }
            return 'Erro ao salvar comentário. Tente novamente.';
        },
        criarComentario() {
            if (!this.podeAdicionarComentario) {
                this.erroComentario =
                    'Apenas super administradores podem adicionar comentários.';
                return;
            }
            this.erroComentario = '';
            const texto = (this.novoComentario || '').trim();
            if (!texto) {
                this.erroComentario = 'Informe o comentário.';
                return;
            }
            if (texto.length > this.MAX_COMENTARIO_LENGTH) {
                this.erroComentario =
                    `Limite de ${this.MAX_COMENTARIO_LENGTH} caracteres excedido ` +
                    `(${texto.length} enviados). Reduza o texto e tente novamente.`;
                return;
            }
            this.loadingSave = true;
            this.tituloService
                .criarComentario(texto, this.id_titulo)
                .then(() => {
                    this.novoComentario = '';
                    this.addComentario = false;
                    this.loadingSave = false;
                    this.$emit('atualizarComentarios');
                })
                .catch(error => {
                    this.loadingSave = false;
                    this.erroComentario = this.extrairMensagemErro(error);
                    console.log(error);
                });
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.text-gray {
    color: #666;
    font-weight: 400;
}
.bg-comentario {
    background-color: #f5f5f5;
    border-radius: 5px;
    margin-bottom: 5px;
}
.v-list {
    max-height: 220px;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 6px; /* Largura da barra de rolagem */
    }

    /* Personalizar o fundo da barra de rolagem (parte que não se move) */
    &::-webkit-scrollbar-track {
        margin-left: 10px;
        background: #fff; /* Cor do fundo */
    }

    /* Personalizar a barra de rolagem móvel */
    &::-webkit-scrollbar-thumb {
        background: #888; /* Cor da barra de rolagem */
        border-radius: 5px; /* Border radius da barra de rolagem */
    }

    /* Personalizar a barra de rolagem quando o mouse está sobre ela */
    &::-webkit-scrollbar-thumb:hover {
        background: #555; /* Cor da barra de rolagem quando o mouse está sobre ela */
    }
}
</style>
